import axios from "axios"
import { getStorage, getStorageR, setStorage, setStorageR, clearStorage } from "./storage"
import Request  from "./request"
import { host, refresh_token } from "./api_urls";

const instance = axios.create({
  baseURL: host + '/api/v1/',
});

instance.interceptors.request.use(
  (config) => {
    const token = getStorage();
    if (token) {
      // config.headers.Authorization = `Bearer ${token}`;
      config.headers["x-access-token"] = `${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Handle network errors (server not reachable)
    // if (!error.response) {
    //   // alert('Server is not working. Please try again later.');
    //   clearStorage();
    //   window.location.href = '/auth/login?redirect=/app/dashboards/default';
    //   return Promise.reject(error);
    // }

    const originalRequest = error.config;
    if ((error?.response?.statusText === 'Unauthorized' || error?.response?.status === 401) && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refresh = getStorageR();
        const response = await Request.postRequest(refresh_token, { refreshToken: refresh });
        const { accessToken, refreshToken } = response.data;
        setStorage(accessToken);
        setStorageR(refreshToken);
        originalRequest.headers["x-access-token"] = `${accessToken}`;
        return axios(originalRequest);
      } catch (error) {
        error.toLogin = true;
        if (error?.response?.status === 403) {
          clearStorage();
          localStorage.removeItem('AUTH_TOKEN');
          window.location.href = '/auth/login?redirect=/app/dashboards/default';
        }
        return Promise.reject(error);
      }
    }

    if (error?.response?.status === 403) {
      clearStorage();
      localStorage.removeItem('AUTH_TOKEN');
      window.location.href = '/auth/login?redirect=/app/dashboards/default';
    }

    return Promise.reject(error);
  }
);

export default instance;